module.exports = __webpack_public_path__ + "static/assets/f382f43d667b784d1bcd8cfe7aa6fff0.mp3";